import React, { useState, useEffect } from 'react'
import { HippostdHtml } from '../blog/blogArticle/componentTypes/HippostdHtml.jsx'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../utility/config/environments.js'
import { BrManageContentButton } from '@bloomreach/react-sdk'

function Headline({ content }) {
  return (
    <div className="u-flex u-flexAlignItemsCenter u-marginBottom5gu">
      <h3 className="u-flexAuto u-textSizeMsrp3 u-textUppercase">{content}</h3>
    </div>
  )
}

const daysToSeconds = (days) => {
  return days * 24 * 60 * 60
}

const DisclaimerModal = ({ page, component }) => {
  //get document data from component settings
  const documentRef = component?.getModels()?.document?.$ref
  const documentImpl = page?.getContent(documentRef)
  const data = documentImpl && documentImpl.getData()
  const { heading, content } = data || {}
  const headlineContent = heading
  const bodyContent = content?.value

  //component parameters
  const parameters = component.getParameters()
  const EXPIRY_TIME = parameters.expiryTimeInDays
    ? daysToSeconds(parameters.expiryTimeInDays)
    : daysToSeconds(30)
  const STORAGE_KEY = parameters.storageKey || 'CM_Modal_Disclaimer_Accepted'
  const redirectUrl = parameters.redirectUrl || '/'
  const [showModal, setShowModal] = useState(false)
  const [privateCheckSelected, setPrivateCheckSelected] = useState(true)

  useEffect(() => {
    let disclaimerAccepted

    try {
      disclaimerAccepted =
        window.sessionStorage.getItem(STORAGE_KEY) ||
        new Date().getTime() <= window.localStorage.getItem(STORAGE_KEY)
    } catch (e) {
      console.error('Error accessing storage for disclaimer:', e)
    }

    if (!disclaimerAccepted && window.location === window.parent.location) {
      setShowModal(true)
    }
  }, [])

  const handleCheck = () => {
    setPrivateCheckSelected(!privateCheckSelected)
  }

  const handleClick = () => {
    try {
      if (privateCheckSelected) {
        window.sessionStorage.removeItem(STORAGE_KEY)
        window.localStorage.setItem(
          STORAGE_KEY,
          new Date().getTime() + 1000 * EXPIRY_TIME
        )
      } else {
        window.localStorage.removeItem(STORAGE_KEY)
        window.sessionStorage.setItem(STORAGE_KEY, true)
      }
    } catch (e) {
      console.error('Error setting disclaimer in storage:', e)
    }

    setShowModal(false)
    return false
  }

  return (
    <div className="u-posRelative">
      {page.isPreview() && (
        <>
          <BrManageContentButton content={documentImpl} />
          <h1>Disclaimer Modal Container</h1>
        </>
      )}
      {showModal && bodyContent && (
        <div id="disclosure-modal-react-app" className="u-posRelative">
          <div className="modal-overlay" />
          <div className="modal-wrapper" aria-modal tabIndex={-1}>
            <div className="modal Content">
              <Headline content={headlineContent} />
              <div className="u-marginBottom5gu">
                <HippostdHtml value={bodyContent} />
                <div className="u-marginTop4gu">
                  <input
                    type="checkbox"
                    id="private-check"
                    name="private-check"
                    checked={privateCheckSelected}
                    onChange={handleCheck}
                  />
                  <label htmlFor="private-check">
                    {' '}
                    I am using a private computer or device.
                  </label>
                </div>
              </div>
              <hr />
              <div className="u-flex u-lg-flexAlignItemsCenter u-sm-flexCol u-md-flexCol u-lg-flexJustifyEnd u-marginTop5gu">
                <a className="u-sm-block u-textCenter" href={redirectUrl}>
                  I do not accept
                </a>
                <button
                  id="disclaimer-accept-button"
                  className="button u-sm-block u-bgColorBrandDark u-marginLeft4gu u-sm-marginRight4gu u-sm-marginTop2gu u-md-marginRight4gu u-md-marginTop2gu u-textColorWhite"
                  onClick={handleClick}
                >
                  I accept
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

// Move fallbackRender outside the component
function DisclaimerModalFallback() {
  return isProduction() ? null : <p>Error in DisclaimerModal component</p>
}

export default function ErrorWrapperDisclaimerModal(props) {
  return (
    <ErrorBoundary fallbackRender={DisclaimerModalFallback}>
      <DisclaimerModal {...props}></DisclaimerModal>
    </ErrorBoundary>
  )
}
